$(() => {
	const CARD_SELECTOR = ".linked-hover-card";
	const TOGGLE_SELECTOR = ".member-copy-toggle";
	const MOBILE_MAX_WIDTH = 599;

	const isMobileInteraction = () =>
		window.innerWidth <= MOBILE_MAX_WIDTH ||
		window.matchMedia("(hover: none) and (pointer: coarse)").matches;

	const collapseAll = (exceptCard = null) => {
		$(CARD_SELECTOR).each((_, card) => {
			if (card !== exceptCard) {
				card.classList.remove("is-expanded");
				const button = card.querySelector(TOGGLE_SELECTOR);
				if (button) {
					button.setAttribute("aria-expanded", "false");
				}
			}
		});
	};

	$(document).on("click", TOGGLE_SELECTOR, (event) => {
		if (!isMobileInteraction()) {
			return;
		}

		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();

		const card = event.currentTarget.closest(CARD_SELECTOR);
		if (!card) {
			return;
		}

		const shouldExpand = !card.classList.contains("is-expanded");

		collapseAll(shouldExpand ? card : null);
		card.classList.toggle("is-expanded", shouldExpand);
		event.currentTarget.setAttribute(
			"aria-expanded",
			shouldExpand ? "true" : "false"
		);
	});

	$(document).on("click", (event) => {
		const clickedInsideCard = $(event.target).closest(CARD_SELECTOR).length > 0;
		if (isMobileInteraction() && !clickedInsideCard) {
			collapseAll();
		}
	});

	$(window).on("resize", () => {
		if (!isMobileInteraction()) {
			collapseAll();
		}
	});
});
